export const customColorOption = "Elegir";
